import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { MaintenanceConfiguration } from '../interfaces/maintenance-configuration.interface';
import { MaintenanceMessage } from '../interfaces/maintenance-message.interface';

@Injectable({
	providedIn: 'root',
})
export class MaintenanceService {
	readonly url: string = 'maintenance';

	constructor(private http: HttpClient) {}

	public getConfiguration(): Observable<MaintenanceConfiguration> {
		return this.http.get<MaintenanceConfiguration>(this.url + '/MaintenanceConfiguration');
	}

	public updateConfiguration(maintenanceConfiguration: MaintenanceConfiguration) {
		return this.http.post<MaintenanceConfiguration>(this.url + '/MaintenanceConfiguration', maintenanceConfiguration);
	}

	public getMaintenanceMessageIfActive(): Observable<MaintenanceMessage> {
		return this.http.get<MaintenanceMessage>(this.url + '/MaintenanceMessage');
	}
}
